module.exports = __webpack_public_path__ + "img/sub_training_icon3.55cd6910.png";